import { createUseStyles } from 'react-jss';


const useStyle = createUseStyles((theme) => ({
  checkBox: {
    cursor: 'pointer',
    userSelect: 'none',
    '& .input': {
      display: 'none',
	  border: '1px solid red',
    },
    '& .input + .little-box': {
      width: theme.sizes.base * 3,
      height: theme.sizes.base * 3,
      display: 'inline-block',
      borderRadius: '4px',
      border: `1px solid ${theme.colors.lightGray.normal}`,
      backgroundColor: theme.colors.background.contrast(5),
      color: theme.colors.background.normal,
      [`margin-${theme.direction.end}`]: '8px',
      verticalAlign: 'middle',
      fontSize: '0',
      transition: 'all .2s ease-in-out',
      '& svg': {
        fill: theme.colors.background.normal,
        display: 'none',
        verticalAlign: 'middle',
      },
    },
    '& .input:checked + .little-box': {
      'border-color': theme.colors.background.normal,
      color: theme.colors.background.normal,
      backgroundColor: theme.colors.primary.normal,
      '& svg': {
        display: 'inline-block',
      },
    },
  },
  disabled: {
    cursor: 'not-allowed',
    'border-color': theme.colors.gray.normal,
    color: theme.colors.gray.normal,
    '& .input:checked + .little-box': {
      backgroundColor: theme.colors.lightGray.contrast(33),
    },
    '& .input:not(:checked) + .little-box': {
      backgroundColor: theme.colors.background.contrast(5),
    },
  },
}));

export default useStyle;
